import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

Alpine.plugin(collapse);

Alpine.store('header', {
  mainNav: document.querySelector('.main-nav'),
  open: !window.matchMedia('(max-width: 768px)').matches,
  mobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  },
  toggle() {
    this.open = !this.open;

    if (this.open) {
      // ios safari hack to prevent scrolling to top of page
      // https://github.com/willmcpo/body-scroll-lock/issues/237
      const storedRequestAnimationFrame = window.requestAnimationFrame;
      window.requestAnimationFrame = () => 42;
      disableBodyScroll(this.mainNav);
      window.requestAnimationFrame = storedRequestAnimationFrame;
      return;
    }

    enableBodyScroll(this.mainNav);
  },
});

Alpine.start();
